import { render } from "./PokemonOptions.vue?vue&type=template&id=839f1a88"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=839f1a88&lang=css"

import exportComponent from "C:\\Wbb\\Portfolio\\Vue Pokemon\\pokemon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__